export interface Summary {
  month: string; count: number; total: number; quota: number; remaining: number
  usagePct: number; daysLeft: number; dailyBudget: number | null
}
export interface Category { category: string; count: number; total: number }
export interface Txn { id: number; amount: number; scene: string; category: string; transaction_time: string }
export interface TrendMonth { month: string; count: number; total: number }

import { api } from './api'
export const moneyApi = {
  seen: () => api.post<{ ok: true; upto: number; badge: number }>('/api/consumption/seen'),
  summary: (month?: string) => api.get<Summary>(`/api/consumption/summary${month ? `?month=${month}` : ''}`),
  categories: (month?: string) => api.get<{ categories: Category[] }>(
    `/api/consumption/categories${month ? `?month=${month}` : ''}`),
  transactions: (limit = 30, month?: string) => api.get<{ transactions: Txn[] }>(
    `/api/consumption/transactions?limit=${limit}${month ? `&month=${month}` : ''}`),
  trend: (months = 6) => api.get<{ months: TrendMonth[]; quota: number }>(`/api/consumption/trend?months=${months}`),
}

/** ¥1,472.02 —— 金额一律千分位，长数字才读得快 */
export const yuan = (n: number) =>
  (n < 0 ? '-' : '') + '¥' + Math.abs(n).toLocaleString('zh-CN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
export const yuanShort = (n: number) =>
  (n < 0 ? '-' : '') + '¥' + Math.abs(Math.round(n)).toLocaleString('zh-CN')
